import React from 'react';
import { Grid } from '@mui/material';
import RTextField from '../../../componentes/forms/inputs/RTextField';
import RSelect from '../../../componentes/forms/inputs/RSelect';

export default function TrabajadorForm({ actualizaCampo, trabajador }) {
  return (
    <form style={{ width: '100%' }}>
      <Grid container spacing={2} sx={{ marginBottom: '30px' }}>
        <RTextField
          type="text"
          name="nombre"
          label="Nombre *"
          actualizaCampo={actualizaCampo}
          value={trabajador.nombre || ''}
          md={4}
        />
        <RSelect
          name="puesto"
          label="Función *"
          actualizaCampo={actualizaCampo}
          value={trabajador.puesto || 'TERAPEUTA'}
          md={4}
          values={[
            { id: 'TERAPEUTA', nombre: 'TERAPEUTA (THER)' },
            { id: 'RECEPCIONISTA', nombre: 'RECEPCIONISTA (RECEP)' }
          ]}
        />
        <RTextField
          type="date"
          name="fechaAlta"
          label="Fecha Alta / Reactivación *"
          actualizaCampo={actualizaCampo}
          value={trabajador.fechaAlta || new Date().toISOString().substring(0, 10)}
          md={4}
        />
        {trabajador.id && (
          <RTextField
            type="date"
            name="fechaBaja"
            label="Fecha Baja (dejar en blanco si está activo)"
            actualizaCampo={actualizaCampo}
            value={trabajador.fechaBaja || ''}
            md={4}
          />
        )}
      </Grid>
    </form>
  );
}
